import type { Address } from '~/types'
import PinIcon from '~/assets/icons/places/pin.svg'

export default (address?: Address | null) => {
  const { $i18n } = useNuxtApp()

  const addressString = useAddressString(address, { country: true }, true)
  if (!address || !addressString) {
    return h('span', $i18n.t('app.blank'))
  }

  const iconSize = '18px'
  return h('div', { class: 'flex items-center border rounded py-1 px-1.5 bg-white' }, [
    h(PinIcon, { class: 'flex-none', style: `width: ${iconSize}!important; height: ${iconSize}!important; margin-right: 2px` }),
    h('span', addressString),
  ])
}
